import { createSlice } from '@reduxjs/toolkit';
import { getStatusMessage } from '../../utils/response-code-messages';
import Snackbar from '../../common/snackBar';
import { get } from 'lodash';
import { menuList } from '../../utils/route-paths';

const page_name = 'settings';
export interface settingsState {
    isScreenLoad: boolean;
    isSettingsDataLoading: boolean;    
    settingsData: Array<any>;
    settingsError: boolean;
    isSettingsAddError: boolean;
    isSettingsUpdateError: boolean;
    isSettingsAddSuccess: boolean;
    isSettingsUpdateSuccess: boolean;
    settingMessage: string;
    menuData: Array<any>; // Added variable for menu data
}

const initialState: settingsState = {
    isScreenLoad: false,
    isSettingsDataLoading: false,
    settingsData: [],
    settingsError: false,
    isSettingsAddError: false,
    isSettingsUpdateError: false,
    isSettingsAddSuccess: false,
    isSettingsUpdateSuccess: false,
    settingMessage: '',
    menuData: [] // Initialize menu data
}

const settingsReducer = createSlice({
    name: page_name,
    initialState: initialState,
    reducers: {
        getSettingsDataRequest: (state, action: { payload: string }) => {            
            state.isSettingsDataLoading = true;            
        },
        getSettingsDataResponse: (state, action) => {   
            state.isScreenLoad = true;          
            state.isSettingsDataLoading = false;
            state.settingsData = action.payload.res.data;                    
        },
        getSettingsDataFailed: (state) => {
            state.isSettingsDataLoading = false;                          
            state.settingsError = true;  
            state.isScreenLoad = true;      
        },
        addSettingsRequest: (state, action: { payload: string }) => {
            state.isSettingsDataLoading = true;
        },
        addSettingsResponse: (state, action) => {
            state.isSettingsDataLoading = false;
            state.isSettingsAddSuccess = true;
            state.isSettingsAddError = false;                        
            const message = getStatusMessage(page_name, action.payload);
            state.settingMessage = message;
            Snackbar.success(message);           
        },
        addSettingsFailed: (state,action) => {
            state.isSettingsDataLoading = false;
            state.isSettingsAddSuccess = false;
            state.isSettingsAddError = true;
            const message = getStatusMessage(page_name, action.payload);
            state.settingMessage = message;
            Snackbar.error(message);
        },
        updateSettingsRequest: (state, action: { payload: string }) => {
            state.isSettingsDataLoading = true;
        },
        updateSettingsResponse: (state, action) => {
            state.isSettingsDataLoading = false;
            state.settingsData = action.payload.res;
            state.isSettingsUpdateSuccess = true;
            state.isSettingsUpdateError = false;
        },
        updateSettingsFailed: (state,action) => {
            state.isSettingsDataLoading = false;
            state.isSettingsUpdateSuccess = false;
            state.isSettingsUpdateError = true;
            const message = getStatusMessage(page_name, action.payload);
            state.settingMessage = message;
            Snackbar.error(message);
        },
        makepreview:(state,action)=>{
            state.settingsData = action.payload
        },
        resetSettings: (state) => {
            state.isSettingsDataLoading = false;
            state.isSettingsAddSuccess =false;
            state.isSettingsAddError = false;  
        },
        getMenuRequest: (state, action: { payload: string }) => {
            state.isSettingsDataLoading = true;
        },
        getMenuResponse: (state, action) => {
            state.isSettingsDataLoading = false;
            state.menuData = get(action,'payload',menuList); // Update menu data
        },
        getMenuFailed: (state, action) => {
            state.isSettingsDataLoading = false;
            state.settingsError = true;
            state.menuData = get(action,'payload',menuList); 
            const message = getStatusMessage(page_name, action.payload);
            state.settingMessage = message;
            // Snackbar.error(message);
        },
    }
})

export const settingsActions = settingsReducer.actions;
export default settingsReducer;